__turbopack_context__.v({
  "accentBar": "LinksTerrace-module-scss-module__hI0y7a__accentBar",
  "blocksBackgroundColor": "LinksTerrace-module-scss-module__hI0y7a__blocksBackgroundColor",
  "blocksFontColor": "LinksTerrace-module-scss-module__hI0y7a__blocksFontColor",
  "card": "LinksTerrace-module-scss-module__hI0y7a__card",
  "cardArrow": "LinksTerrace-module-scss-module__hI0y7a__cardArrow",
  "cardTitle": "LinksTerrace-module-scss-module__hI0y7a__cardTitle",
  "count": "LinksTerrace-module-scss-module__hI0y7a__count",
  "folderButton": "LinksTerrace-module-scss-module__hI0y7a__folderButton",
  "folderCard": "LinksTerrace-module-scss-module__hI0y7a__folderCard",
  "iconChip": "LinksTerrace-module-scss-module__hI0y7a__iconChip",
  "link": "LinksTerrace-module-scss-module__hI0y7a__link",
  "linkCard": "LinksTerrace-module-scss-module__hI0y7a__linkCard",
  "linkIconChip": "LinksTerrace-module-scss-module__hI0y7a__linkIconChip",
  "linkList": "LinksTerrace-module-scss-module__hI0y7a__linkList",
  "linkScroll": "LinksTerrace-module-scss-module__hI0y7a__linkScroll",
  "secondaryNavBackgroundColor": "LinksTerrace-module-scss-module__hI0y7a__secondaryNavBackgroundColor",
  "themeBackgroundColor": "LinksTerrace-module-scss-module__hI0y7a__themeBackgroundColor",
  "themeFontColor": "LinksTerrace-module-scss-module__hI0y7a__themeFontColor",
});
